import axios from 'axios'
import {HIDE_LOGIN_MODAL, HIDE_PASSWORD_MODAL, SHOW_PASSWORD_RESET_TOKEN, TOGGLE_PASSWORD_MODAL} from "./content";
import { push } from 'connected-react-router'

export const LOGIN = 'auth/LOGIN'
export const REGISTER = 'auth/REGISTER'
export const TOKEN = 'auth/TOKEN'
export const USER = 'auth/USER'
export const SHARE = 'auth/SHARE'
export const SHARE_ERROR = 'auth/SHARE_ERROR'
export const REGISTRATION_ERROR = 'auth/REGISTRATION_ERROR'
export const SCORE = 'auth/SCORE'
export const COUNTRIES = 'auth/COUNTRIES'
export const LOGOUT = 'auth/LOGOUT'
export const READ_WARNING = 'auth/READ_WARNING'
export const SHOW_WARNING = 'auth/SHOW_WARNING'
export const FORGOT_PASSWORD_REQUESTED = 'auth/FORGOT_PASSWORD_REQUESTED'
export const RESET_PASSWORD_RESET_TOKEN = 'auth/RESET_PASSWORD_RESET_TOKEN'
export const LOGIN_ERROR = 'auth/LOGIN_ERROR'
export const PASSWORD_RESET_ERROR = 'auth/PASSWORD_RESET_ERROR'

let initialState = {
	isRequestingData: false,
	token: null,
	user: {},
	share: {},
	hasReadWarning: false,
	error: null,
	countries: [],
	password_reset_token: null,
	loginError: null,
	passwordResetError: null
}

export default (state = initialState, action) => {
	switch (action.type) {
		case HIDE_PASSWORD_MODAL:
		case TOGGLE_PASSWORD_MODAL:
			return {
				...state,
				password_reset_token: null,
				passwordResetError: null
			}
		case LOGIN_ERROR:
			return {
				...state,
				loginError: action.payload
			}
		case PASSWORD_RESET_ERROR:
			return {
				...state,
				passwordResetError: action.payload
			}
		case RESET_PASSWORD_RESET_TOKEN:
			return {
				...state,
				password_reset_token: null
			}
		case READ_WARNING:
			return {
				...state,
				hasReadWarning: true
			}
		case SHOW_WARNING:
			return {
				...state,
				hasReadWarning: false
			}
		case COUNTRIES:
			return {
				...state,
				countries: action.payload
			}
		case REGISTRATION_ERROR:
			return {
				...state,
				error: action.payload
			}
		case SCORE:
			return {
				...state,
				user: {
					...state.user,
					Score: action.payload.Score,
					EntriesCount: action.payload.EntriesCount
				}
			}
		case TOKEN:
			return {
				...state,
				token: action.payload,
				isRequestingData: false
			}

		case USER:
			return {
				...state,
				user: action.payload,
				isRequestingData: false
			}

		case LOGOUT:
			return {...initialState}

		default:
			return state
	}
}

export const hasReadWarning = () => {
	return dispatch => {
		dispatch({
			type: READ_WARNING
		})
	}
}

export const showWarning = () => {
	return dispatch => {
		dispatch({
			type: SHOW_WARNING
		})
	}
}

export const share = () => {
	return (dispatch, getState) => {
		axios.post('https://incident-response-challenge.com/middleware/share', getState().auth.share).then((response) => {
			if(response.data.response === 1){
				dispatch({
					type: SHARE
				})
			}
			else {
				dispatch({
					type: SHARE_ERROR
				})
			}
		})
	}
}

export const forgotPasswordToken = () => {
	return (dispatch, getState) => {
		dispatch({
			type: RESET_PASSWORD_RESET_TOKEN
		})
		axios.post('https://incident-response-challenge.com/middleware/forgot-password', {
			email_address: getState().auth.user.email_address
		}).then((response) => {
			if(!response.data.error) {
				dispatch({
					type: SHOW_PASSWORD_RESET_TOKEN
				})
			}
			else {
				dispatch({
					type: PASSWORD_RESET_ERROR,
					payload: response.data.details
				})
			}
		})
	}
}

export const forgotPassword = () => {
	return (dispatch, getState) => {
		axios.post('https://incident-response-challenge.com/middleware/forgot-password', {
			email_address: getState().auth.user.email_address,
			password: getState().auth.user.password,
			token: getState().auth.password_reset_token
		}).then((response) => {
			if(!response.data.error) {
				dispatch({
					type: HIDE_PASSWORD_MODAL
				})

				dispatch(login())
			}
			else {
				dispatch({
					type: PASSWORD_RESET_ERROR,
					payload: response.data.details
				})
			}
		})
	}
}

export const getCountries = () => {
	return (dispatch, getState) => {
		const token = getState().auth.token;

		axios.get('https://incident-response-challenge.com/middleware/countries')
			.then((response) => {
				if (!!response.data) {
					dispatch({
						type: COUNTRIES,
						payload: response.data
					})
				}
			})
	}
}

export const getScore = () => {
	return (dispatch, getState) => {
		const token = getState().auth.token;

		axios.get('https://incident-response-challenge.com/middleware/score', {
			headers: {
				'Authorization': 'Bearer ' + token
			}}).then((response) => {
			if(!!response.data){
				dispatch({
					type: SCORE,
					payload: response.data
				})
			}
		})
	}
}

export const register = () => {
	return (dispatch, getState) => {
		dispatch({
			type: REGISTRATION_ERROR,
			payload: null
		})

		axios.post('https://incident-response-challenge.com/middleware/register', getState().auth.user).then((response) => {
			if(!!response.data.token){
				dispatch({
					type: TOKEN,
					payload: response.data.token
				})

				dispatch({
					type: USER,
					payload: response.data.user
				})

				dispatch(push('/activation'));
			}
			else {
				dispatch({
					type: REGISTRATION_ERROR,
					payload: response.data.error
				})
			}
		})
	}
}

export const activate = () => {
	return (dispatch, getState) => {
		const token = getState().auth.token;

		dispatch({
			type: REGISTRATION_ERROR,
			payload: null
		})

		axios.post('https://incident-response-challenge.com/middleware/activate', getState().auth.user, {
			headers: {
				'Authorization': 'Bearer ' + token
			}}).then((response) => {
			if(!!response.data.token){
				dispatch({
					type: TOKEN,
					payload: response.data.token
				})

				dispatch({
					type: USER,
					payload: response.data.user
				})

				dispatch(push('/'));
			}
			else {
				dispatch({
					type: REGISTRATION_ERROR,
					payload: response.data.error
				})
			}
		})
	}
}

export const logout = () => {
	return dispatch => {
		dispatch({
			type: LOGOUT
		})

		dispatch(push('/'));
	}
}

export const login = () => {
	return (dispatch, getState) => {
		dispatch({
			type: LOGIN_ERROR,
			payload: null
		})

		axios.post('https://incident-response-challenge.com/middleware/token', {
			email_address: getState().auth.user.email_address,
			password: getState().auth.user.password
		}).then((response) => {
			if(!!response.data.token){
				dispatch({
					type: USER,
					payload: response.data.user
				})

				dispatch({
					type: HIDE_LOGIN_MODAL
				})

				dispatch({
					type: TOKEN,
					payload: response.data.token
				})

				if(!response.data.user.Active){
					dispatch(push('/activation'));
				}
			}
			else {
				dispatch({
					type: LOGIN_ERROR,
					payload: 'Incorrect email/password'
				})
			}
		}).catch(() => {
			dispatch({
				type: LOGIN_ERROR,
				payload: 'Incorrect email/password'
			})
		})
	}
}